import type { SupportedLocale } from '@erp/shared';
export const conditionsTranslations = {
  de: {
    title: 'Konditionen',
    description:
      'Zahlungs- und Lieferbedingungen direkt verwalten. Kunden und Lieferadressen verwenden dieselbe Auswahl.',
    payment: 'Zahlungsbedingungen',
    delivery: 'Lieferbedingungen',
    categories: 'Kundenkategorien',
    categoriesDescription:
      'Branchen und eigene Kundengruppen anlegen, benennen und deaktivieren. Preisgruppen bestimmen separat die Artikelpreise.',
    priceGroups: 'Preisgruppen verwalten',
    add: 'Hinzufügen',
    name: 'Bezeichnung',
    scope: 'Verwendung',
    SALES: 'Verkauf',
    PURCHASE: 'Einkauf',
    BOTH: 'Verkauf und Einkauf',
    dueDays: 'Zahlungsziel in Tagen',
    cashDiscountPct: 'Skonto in %',
    cashDiscountDays: 'Skontofrist in Tagen',
    isDefault: 'Als Standard verwenden',
    isActive: 'Für neue Auswahlen aktiv',
    inactive: 'Deaktiviert',
    default: 'Standard',
    advanced: 'Weitere Angaben und Übersetzungen',
    incoterm: 'Incoterm',
    code: 'Code',
    saved: 'Gespeichert.',
    error: 'Speichern fehlgeschlagen. Bitte Eingaben prüfen und erneut versuchen.',
    invalid: 'Bitte die markierten Eingaben prüfen.',
    loadError: 'Die Auswahl konnte nicht geladen werden.',
    empty: 'Noch keine Einträge. Legen Sie den ersten Eintrag an.',
    deliveryField: 'Lieferkondition',
    inherit: 'Kundenkondition übernehmen: {{value}}',
    none: 'Keine Lieferkondition',
    manage: 'Lieferbedingungen verwalten',
    manageCategories: 'Kundenkategorien verwalten',
    search: 'Bezeichnung suchen',
    legacy: 'Bisheriger individueller Wert',
    categoryField: 'Kundenkategorie / Branche',
    categoryUnknown: 'Bitte eine aktive Kundenkategorie auswählen.',
    usage: '{{count}} Zuordnungen',
    help: 'Hilfe zu Konditionen und Kundenkategorien',
    keywords:
      'Konditionen Zahlungsziel Skonto Lieferbedingungen Kundenkategorien Branchen Kundengruppen',
  },
  en: {
    title: 'Terms and conditions',
    description:
      'Manage payment and delivery terms directly. Customers and shipping addresses share the same selection.',
    payment: 'Payment terms',
    delivery: 'Delivery terms',
    categories: 'Customer categories',
    categoriesDescription:
      'Create, name and deactivate industries and your own customer categories. Price groups determine product prices separately.',
    priceGroups: 'Manage price groups',
    add: 'Add',
    name: 'Name',
    scope: 'Usage',
    SALES: 'Sales',
    PURCHASE: 'Purchasing',
    BOTH: 'Sales and purchasing',
    dueDays: 'Payment due in days',
    cashDiscountPct: 'Cash discount in %',
    cashDiscountDays: 'Discount period in days',
    isDefault: 'Use as default',
    isActive: 'Active for new selections',
    inactive: 'Inactive',
    default: 'Default',
    advanced: 'More details and translations',
    incoterm: 'Incoterm',
    code: 'Code',
    saved: 'Saved.',
    error: 'Could not save. Check your entries and try again.',
    invalid: 'Check the highlighted entries.',
    loadError: 'The selection could not be loaded.',
    empty: 'No entries yet. Add the first entry.',
    deliveryField: 'Delivery terms',
    inherit: 'Use customer terms: {{value}}',
    none: 'No delivery terms',
    manage: 'Manage delivery terms',
    manageCategories: 'Manage customer categories',
    search: 'Search by name',
    legacy: 'Previous individual value',
    categoryField: 'Customer category / industry',
    categoryUnknown: 'Select an active customer category.',
    usage: '{{count}} assignments',
    help: 'Help with terms and customer categories',
    keywords: 'terms payment discount delivery customer categories industries groups',
  },
  fr: {
    title: 'Conditions',
    description:
      'Gérez directement les conditions de paiement et de livraison. Clients et adresses de livraison partagent la même sélection.',
    payment: 'Conditions de paiement',
    delivery: 'Conditions de livraison',
    categories: 'Catégories de clients',
    categoriesDescription:
      'Créez, nommez et désactivez des secteurs et vos catégories de clients. Les groupes de prix déterminent séparément les prix des articles.',
    priceGroups: 'Gérer les groupes de prix',
    add: 'Ajouter',
    name: 'Libellé',
    scope: 'Utilisation',
    SALES: 'Ventes',
    PURCHASE: 'Achats',
    BOTH: 'Ventes et achats',
    dueDays: 'Délai de paiement en jours',
    cashDiscountPct: 'Escompte en %',
    cashDiscountDays: 'Délai d’escompte en jours',
    isDefault: 'Utiliser par défaut',
    isActive: 'Actif pour les nouvelles sélections',
    inactive: 'Désactivé',
    default: 'Par défaut',
    advanced: 'Détails et traductions',
    incoterm: 'Incoterm',
    code: 'Code',
    saved: 'Enregistré.',
    error: 'Échec de l’enregistrement. Vérifiez les saisies et réessayez.',
    invalid: 'Vérifiez les saisies signalées.',
    loadError: 'Impossible de charger la sélection.',
    empty: 'Aucune entrée. Ajoutez la première.',
    deliveryField: 'Condition de livraison',
    inherit: 'Reprendre la condition du client : {{value}}',
    none: 'Aucune condition de livraison',
    manage: 'Gérer les conditions de livraison',
    manageCategories: 'Gérer les catégories de clients',
    search: 'Rechercher un libellé',
    legacy: 'Ancienne valeur individuelle',
    categoryField: 'Catégorie de client / secteur',
    categoryUnknown: 'Sélectionnez une catégorie de client active.',
    usage: '{{count}} affectations',
    help: 'Aide sur les conditions et catégories de clients',
    keywords: 'conditions paiement escompte livraison catégories clients secteurs groupes',
  },
  es: {
    title: 'Condiciones',
    description:
      'Gestione directamente las condiciones de pago y entrega. Clientes y direcciones de entrega usan la misma selección.',
    payment: 'Condiciones de pago',
    delivery: 'Condiciones de entrega',
    categories: 'Categorías de clientes',
    categoriesDescription:
      'Cree, nombre y desactive sectores y categorías propias de clientes. Los grupos de precios determinan por separado los precios de artículos.',
    priceGroups: 'Gestionar grupos de precios',
    add: 'Añadir',
    name: 'Nombre',
    scope: 'Uso',
    SALES: 'Ventas',
    PURCHASE: 'Compras',
    BOTH: 'Ventas y compras',
    dueDays: 'Plazo de pago en días',
    cashDiscountPct: 'Descuento por pronto pago en %',
    cashDiscountDays: 'Plazo de descuento en días',
    isDefault: 'Usar por defecto',
    isActive: 'Activo para nuevas selecciones',
    inactive: 'Desactivado',
    default: 'Predeterminado',
    advanced: 'Más detalles y traducciones',
    incoterm: 'Incoterm',
    code: 'Código',
    saved: 'Guardado.',
    error: 'No se pudo guardar. Revise los datos e inténtelo de nuevo.',
    invalid: 'Revise los datos marcados.',
    loadError: 'No se pudo cargar la selección.',
    empty: 'Todavía no hay entradas. Añada la primera.',
    deliveryField: 'Condición de entrega',
    inherit: 'Usar la condición del cliente: {{value}}',
    none: 'Sin condición de entrega',
    manage: 'Gestionar condiciones de entrega',
    manageCategories: 'Gestionar categorías de clientes',
    search: 'Buscar por nombre',
    legacy: 'Valor individual anterior',
    categoryField: 'Categoría de cliente / sector',
    categoryUnknown: 'Seleccione una categoría de cliente activa.',
    usage: '{{count}} asignaciones',
    help: 'Ayuda sobre condiciones y categorías de clientes',
    keywords: 'condiciones pago descuento entrega categorías clientes sectores grupos',
  },
  tr: {
    title: 'Koşullar',
    description:
      'Ödeme ve teslimat koşullarını doğrudan yönetin. Müşteriler ve teslimat adresleri aynı seçimi kullanır.',
    payment: 'Ödeme koşulları',
    delivery: 'Teslimat koşulları',
    categories: 'Müşteri kategorileri',
    categoriesDescription:
      'Sektörleri ve kendi müşteri kategorilerinizi oluşturun, adlandırın ve devre dışı bırakın. Fiyat grupları ürün fiyatlarını ayrıca belirler.',
    priceGroups: 'Fiyat gruplarını yönet',
    add: 'Ekle',
    name: 'Ad',
    scope: 'Kullanım',
    SALES: 'Satış',
    PURCHASE: 'Satın alma',
    BOTH: 'Satış ve satın alma',
    dueDays: 'Ödeme vadesi (gün)',
    cashDiscountPct: 'Erken ödeme indirimi (%)',
    cashDiscountDays: 'İndirim süresi (gün)',
    isDefault: 'Varsayılan olarak kullan',
    isActive: 'Yeni seçimler için etkin',
    inactive: 'Devre dışı',
    default: 'Varsayılan',
    advanced: 'Diğer bilgiler ve çeviriler',
    incoterm: 'Incoterm',
    code: 'Kod',
    saved: 'Kaydedildi.',
    error: 'Kaydedilemedi. Girişleri kontrol edip tekrar deneyin.',
    invalid: 'İşaretli girişleri kontrol edin.',
    loadError: 'Seçenekler yüklenemedi.',
    empty: 'Henüz kayıt yok. İlk kaydı ekleyin.',
    deliveryField: 'Teslimat koşulu',
    inherit: 'Müşteri koşulunu kullan: {{value}}',
    none: 'Teslimat koşulu yok',
    manage: 'Teslimat koşullarını yönet',
    manageCategories: 'Müşteri kategorilerini yönet',
    search: 'Ada göre ara',
    legacy: 'Önceki özel değer',
    categoryField: 'Müşteri kategorisi / sektör',
    categoryUnknown: 'Etkin bir müşteri kategorisi seçin.',
    usage: '{{count}} atama',
    help: 'Koşullar ve müşteri kategorileri yardımı',
    keywords: 'koşullar ödeme indirim teslimat müşteri kategorileri sektörler gruplar',
  },
} satisfies Record<SupportedLocale, Record<string, string>>;
